(async () => {
  const source = document.currentScript?.dataset.navigationSource;
  const preparedSource = document.currentScript?.dataset.navigationPreparedSource;
  const directorySource = document.currentScript?.dataset.navigationDirectorySource;
  // Explicit approved aliases only; never fuzzy-match pattern or maker names.
  const makerAliases = {'Villeory & Boch':'Villeroy & Boch','Wedgood':'Wedgwood','Phillipe Deshoulieres':'Philippe Deshoulières','Philippe Deshoulieres':'Philippe Deshoulières','Fitz &amp; Floyd':'Fitz & Floyd'};
  const patternAliases = {
    'Adams':{'SIngapore Bird':'Singapore Bird'},
    'Bernardaud':{'Pheobe Platine':'Phoebe Platine'},
    'Denby':{'Cotswald':'Cotswold','Potpourii Blue':'Potpourri Blue'},
    'Fitz & Floyd':{'Paltinum Rondelet':'Platinum Rondelet'},
    'Franciscan':{'Sea Scupltures The Sand Dollar':'Sea Sculptures The Sand Dollar'},
    'Lenox':{'Braclay':'Barclay','Springdale NO PIC USE OLD ONE':'Springdale','Staccato Red &amp; Blue':'Staccato Red & Blue','Poppies On Blue':'Poppies on Blue'},
    'Mikasa':{'Chairmaine':'Charmaine','Water Lillies Yellow':'Water Lilies Yellow'},
    'Minton':{'Cukoo':'Cuckoo','Edinbugh':'Edinburgh','Wimbeldon':'Wimbledon'},
    'Royal Doulton':{'Fasicnation':'Fascination','Fosyth':'Forsyth'},
    'Spode':{'Royal WIndsor':'Royal Windsor','Ribbons &amp; Bows':'Ribbons & Bows'},
    'Wedgwood':{'Runnmede Blue':'Runnymede Blue','Williamsburg Potpourii':'Williamsburg Potpourri',"Queen'S Plain":"Queen's Plain"}
  };
  const categoryMakerAliases = {
    China:makerAliases,
    Crystal:{'Unkown':'Unknown','St Louis':'St. Louis','Royal Leerdam - Netherland':'Royal Leerdam - Netherlands'},
    Flatware:{'Hagrety':'Hagerty','Kirk Steiff':'Kirk Stieff'},
    Collectibles:{'Elephent':'Elephant'}
  };
  const categoryPatternAliases = {
    China:patternAliases,
    Crystal:{'Lenox':{'Noveau':'Nouveau'},'Varga':{'Daisys':'Daisies'},'Unknown':{'Unkown':'Unknown','Unkown (Style 1)':'Unknown (Style 1)','Unkown (Style 2)':'Unknown (Style 2)'}},
    Flatware:{'Oneida':{'Golden Golden Royal Flute ((Golden)':'Golden Royal Flute (Golden)','Golden Golden Royal Flute (Golden)':'Golden Royal Flute (Golden)'}}
  };
  const canonicalMaker = (cat,name) => Object.hasOwn(categoryMakerAliases[cat] || {},name) ? categoryMakerAliases[cat][name] : name;
  const canonicalPattern = (cat,maker,name) => Object.hasOwn(categoryPatternAliases[cat]?.[canonicalMaker(cat,maker)] || {},name) ? categoryPatternAliases[cat][canonicalMaker(cat,maker)][name] : name;
  const canonicalIdentity = row => {
    if (!row || typeof row !== 'object' || Array.isArray(row)) return row;
    const maker=canonicalMaker(row.category,row.manufacturer);
    return {...row,manufacturer:maker,pattern:canonicalPattern(row.category,maker,row.pattern)};
  };
  const canonicalHref = href => {
    if (typeof href !== 'string') return href;
    const url=new URL(href,location.origin);
    if (url.origin!==location.origin || url.pathname!=='/pages/navigation') return href;
    const cat=url.searchParams.get('nav'), maker=canonicalMaker(cat,url.searchParams.get('manufacturer'));
    if (maker) url.searchParams.set('manufacturer',maker);
    if (url.searchParams.has('pattern')) url.searchParams.set('pattern',canonicalPattern(cat,maker,url.searchParams.get('pattern')));
    return url.pathname+'?'+url.searchParams.toString();
  };
  const mergeIdentityRows = rows => {
    const grouped=new Map();
    for (const raw of rows) {
      const row=canonicalIdentity(raw), key=JSON.stringify([row.category,row.manufacturer,row.pattern]);
      if (!grouped.has(key)) {grouped.set(key,{...row,products:[...(row.products || [])]});continue;}
      const target=grouped.get(key), urls=new Set(target.products.map(p=>p.url));
      for (const product of row.products || []) if (!urls.has(product.url)) {target.products.push(product);urls.add(product.url);}
    }
    return [...grouped.values()];
  };
  const normalizePayload = data => {
    if (Array.isArray(data)) return data.length && data.every(row=>row && typeof row==='object' && !Array.isArray(row) && row.category && row.manufacturer && row.pattern) ? mergeIdentityRows(data) : data;
    if (!data || typeof data!=='object') return data;
    const result={...data};
    if (result.category && result.manufacturer && result.pattern) Object.assign(result,canonicalIdentity(result));
    if (result.native) result.native=canonicalIdentity(result.native);
    if (Array.isArray(result.products)) result.products=result.products.map(normalizePayload);
    if (Array.isArray(result.navigation)) result.navigation=result.navigation.map(canonicalIdentity);
    const prepared=(rows,cat)=>{
      const seen=new Set();
      return rows.map(row=>{if(!Array.isArray(row)||row.length!==3)return row;const maker=canonicalMaker(cat,row[0]);return [maker,canonicalPattern(cat,maker,row[1]),canonicalHref(row[2])];}).filter(row=>{const key=JSON.stringify(row);if(seen.has(key))return false;seen.add(key);return true;});
    };
    if (result.schema===1 && Array.isArray(result.rows)) result.rows=prepared(result.rows,result.category);
    if (result.schema===1 && result.categories) result.categories=Object.fromEntries(Object.entries(result.categories).map(([cat,rows])=>[cat,prepared(rows,cat)]));
    return result;
  };
  const normalizeDirectoryDOM = page => {
    for (const section of page.querySelectorAll('.cr-navigation-category')) {
      const makers=new Map();
      for (const details of [...section.querySelectorAll('.cr-manufacturer')]) {
        const cat=section.dataset.category, maker=canonicalMaker(cat,details.dataset.manufacturer);details.dataset.manufacturer=maker;
        if (makers.has(maker)) {for(const item of [...details.querySelectorAll('.cr-patterns li')])makers.get(maker).querySelector('.cr-patterns').append(item);details.remove();}
        else makers.set(maker,details);
      }
      for(const [maker,details] of makers){const seen=new Set();for(const item of [...details.querySelectorAll('.cr-patterns li')]){const link=item.querySelector('a');if(!link)continue;const name=canonicalPattern(section.dataset.category,maker,link.textContent.trim());if(seen.has(name)){item.remove();continue;}seen.add(name);link.textContent=name;link.href=canonicalHref(link.getAttribute('href'));}}
    }
  };

  // Pattern guides are optional and never gate stock, product data or photos.
  const informationSource=document.currentScript?.dataset.patternInformationSource;
  const informationMakerFiles=new Set(["0201ea58","098e9bfa","0b021fb1","0bd44273","0c421dea","0e518334","0f555cc2","0fa3fe57","1c1f17db","2095c3a7","2780964a","2ede6801","300b4b0b","306b98b8","34d4c112","38d89f9c","3af3153f","3bef9b18","3c5499f5","472832c2","5bed7085","5efd95dd","641ff37c","69db5305","6f1115dd","6f40d407","7092c6d2","725fd96b","75bc3968","7b41bc7b","7df4792a","853742d1","877a845a","8c1d832a","8cc0a2ad","8e970eba","8f9f80d0","91384688","915fc8d7","a05e5d4d","a1d6ff1c","a40198e5","a666de17","aa5ee2b5","ad7d12a5","b0b7a78b","b0caf5ee","b4b190ce","b5467517","b60e725e","ba7c7019","bda83c4c","c22799b6","c28d9985","c3371dab","c8fdecfa","ca5c5341","cc10a96c","cd830fa9","d41d9ee8","d84a43d0","e03d8d5a","e2f8f488","e7f4d00d","f13a47cc","fd512048"]);
  const informationMakerKey=identity=>{let hash=2166136261;const text=JSON.stringify(identity.slice(0,2));for(let i=0;i<text.length;i++)hash=Math.imul(hash^text.charCodeAt(i),16777619);return (hash>>>0).toString(16).padStart(8,'0');};
  const setNavigationSEO=(category,maker,pattern)=>{
    const path=category?navigationUrl(category,maker,pattern):'/pages/navigation';
    for(const old of document.head.querySelectorAll('link[rel="canonical"]'))old.remove();
    const canonical=document.createElement('link');canonical.rel='canonical';canonical.href=new URL(path,location.origin).href;document.head.append(canonical);
    if(category)document.title=[maker,pattern,category].filter(Boolean).join(' ')+' | Classic Replacements';
  };
  const renderPatternInformation=async (panel, identity)=>{
    if(!informationSource)return;
    try{
      const makerKey=informationMakerKey(identity);if(!informationMakerFiles.has(makerKey))return;
      const informationUrl=new URL(informationSource,location.origin);informationUrl.pathname=informationUrl.pathname.replace(/cr-pattern-information\.json$/,'cr-pattern-information-'+makerKey+'.json');
      const response=await fetch(informationUrl.href,{signal:AbortSignal.timeout(8000)});
      if(!response.ok)return;
      const data=await response.json();
      if(data?.schema!==1||!Array.isArray(data.entries))return;
      const matches=data.entries.filter(entry=>Array.isArray(entry.identity)&&JSON.stringify(entry.identity)===JSON.stringify(identity));
      if(matches.length!==1)return;
      const entry=matches[0];
      if(!Array.isArray(entry.paragraphs)||!entry.paragraphs.length||entry.paragraphs.some(p=>typeof p!=='string'||!p.trim())||!Array.isArray(entry.facts)||entry.facts.some(f=>!Array.isArray(f)||f.length!==2||f.some(v=>typeof v!=='string')))return;
      const section=document.createElement('section');section.className='cr-pattern-information';section.setAttribute('aria-labelledby','cr-pattern-information-title');
      const heading=document.createElement('h2');heading.id='cr-pattern-information-title';heading.textContent='About '+identity[1]+' '+identity[2];section.append(heading);
      const first=entry.paragraphs[0],excerpt=first.length>220?first.split(/(?<=[.!?])\s+/)[0]:first;
      const introduction=document.createElement('p');introduction.textContent=excerpt;section.append(introduction);
      if(excerpt!==first||entry.paragraphs.length>1||entry.facts.length){
        const details=document.createElement('details'),summary=document.createElement('summary');summary.textContent='More pattern information';details.append(summary);
        for(const text of entry.paragraphs.slice(excerpt===first?1:0)){const p=document.createElement('p');p.textContent=text;details.append(p);}
        if(entry.facts.length){const facts=document.createElement('dl');for(const [label,value] of entry.facts){const group=document.createElement('div'),term=document.createElement('dt'),definition=document.createElement('dd');term.textContent=label;definition.textContent=value;group.append(term,definition);facts.append(group);}details.append(facts);}
        const note=document.createElement('p');note.className='cr-pattern-information-note';note.textContent='Adapted from our earlier pattern guide. Check individual product photos and descriptions when matching your set.';details.append(note);section.append(details);
      }
      const style=document.createElement('style');style.textContent='.cr-pattern-information{max-width:88rem;margin:2rem 0 3rem;padding:2rem 2.4rem;background:#f7f9fa;border-left:3px solid #126792;border-radius:0 6px 6px 0}.cr-pattern-information h2{font-size:2.3rem;margin:0 0 1.2rem}.cr-pattern-information p{line-height:1.7;margin:0 0 1.2rem}.cr-pattern-information dl{display:flex;flex-wrap:wrap;gap:1.2rem 3rem;margin:1.6rem 0}.cr-pattern-information dt{font-weight:600;font-size:1.3rem}.cr-pattern-information dd{margin:0}.cr-pattern-information .cr-pattern-information-note{font-size:1.2rem;margin-bottom:0;color:#555}@media(max-width:749px){.cr-pattern-information{padding:1.5rem}.cr-pattern-information h2{font-size:2rem}.cr-pattern-information dl{display:block}.cr-pattern-information dl>div{margin-bottom:1rem}}';section.append(style);
      style.textContent+='.cr-pattern-information summary{cursor:pointer;text-decoration:underline;color:#126792;font-size:1.4rem}.cr-pattern-information details[open] summary{margin-bottom:1rem}';
      if(!panel.querySelector('.cr-pattern-information'))panel.querySelector('.cr-piece-status').before(section);
      let description=document.head.querySelector('meta[name="description"]');if(!description){description=document.createElement('meta');description.name='description';document.head.append(description);}description.content=entry.paragraphs[0].replace(/\s+/g,' ').slice(0,160);
    }catch{/* Missing archive content must not interfere with the catalogue. */}
  };

  const params = new URLSearchParams(location.search);
  const category = params.get('nav');
  const setPieceImagePriority = (image, list) => {
    const firstPhoto = !list.querySelector('img');
    image.loading = firstPhoto ? 'eager' : 'lazy';
    image.fetchPriority = firstPhoto ? 'high' : 'auto';
  };
  const manufacturer = canonicalMaker(category,params.get('manufacturer'));
  const pattern = canonicalPattern(category,manufacturer,params.get('pattern'));
  const page = document.querySelector('.cr-navigation');
  const readRawJSON = async (url, options, missingVendor) => {
    const key = 'cr-navigation-cache-v2:' + source + ':' + url;
    try {
      const cached = JSON.parse(sessionStorage.getItem(key));
      if (cached && Date.now() - cached.time < 60000) return cached.data;
    } catch {}
    const early = globalThis.__crNavigationEarly?.get(new URL(url, location.origin).href);
    if (early) {
      const data = await early;
      if (data !== null) return data;
    }
    const response = await fetch(url, options);
    if (response.status === 404 && missingVendor) return {vendor:missingVendor,page:1,pages:1,total:0,products:[]};
    if (!response.ok) throw new Error('Navigation data unavailable');
    const data = await response.json();
    try { sessionStorage.setItem(key, JSON.stringify({time:Date.now(),data})); } catch {}
    return data;
  };

  const readJSON = async (url, options) => {
    const request=new URL(url,location.origin);
    if (request.pathname==='/collections/vendors' && request.searchParams.get('view')==='cr-pattern' && request.searchParams.get('page')==='1') {
      const requested=request.searchParams.get('q');
      const canonical=canonicalPattern(category,manufacturer,requested);
      const names=[...new Set([canonical,...Object.keys(categoryPatternAliases[category]?.[manufacturer] || {}).filter(name=>canonicalPattern(category,manufacturer,name)===canonical)])];
      if (names.length>1) {
        const all=await Promise.all(names.map(async name=>{
          const base=new URL(request);base.searchParams.set('q',name);
          const first=await readRawJSON(base.href,options,name);
          const valid=(data,n)=>data && Array.isArray(data.products) && data.vendor?.toLocaleLowerCase()===name.toLocaleLowerCase() && Number.isInteger(data.pages) && data.pages>=1 && data.pages<=100 && data.page===n && Number.isInteger(data.total) && data.total>=0;
          if(!valid(first,1))throw Error('Invalid alias pattern data');
          const products=[...first.products];const queue=Array.from({length:first.pages-1},(_,i)=>i+2);
          await Promise.all(Array.from({length:Math.min(4,queue.length)},async()=>{while(queue.length){const n=queue.shift(),next=new URL(base);next.searchParams.set('page',n);const part=await readRawJSON(next.href,options);if(!valid(part,n)||part.total!==first.total||part.pages!==first.pages)throw Error('Incomplete alias data');products.push(...part.products);}}));
          if(products.length!==first.total)throw Error('Alias product count changed');return products;
        }));
        const products=new Map();for(const raw of all.flat()){const product=normalizePayload(raw);if(products.has(product.url)&&JSON.stringify(products.get(product.url).native)!==JSON.stringify(product.native))throw Error('Conflicting alias product');products.set(product.url,product);}
        return {vendor:canonical,page:1,pages:1,total:products.size,products:[...products.values()]};
      }
    }
    return normalizePayload(await readRawJSON(url,options));
  };

  const navigationUrl = (categoryName, manufacturerName, patternName) => '/pages/navigation?nav=' + encodeURIComponent(categoryName) + (manufacturerName ? '&manufacturer=' + encodeURIComponent(manufacturerName) : '') + (patternName ? '&pattern=' + encodeURIComponent(patternName) : '');
  const breadcrumbs = (target, parts) => {
    target.replaceChildren();
    parts.forEach((part, index) => {
      if (index) target.append(document.createTextNode(' › '));
      const node = document.createElement(part.url && index < parts.length - 1 ? 'a' : 'span');
      node.textContent = part.text;
      if (node.tagName === 'A') node.href = part.url;
      else if (index === parts.length - 1) node.setAttribute('aria-current', 'page');
      target.append(node);
    });
  };
  // User Timing records actual directory readiness, which LCP alone misses.
  performance.mark('cr-navigation-start');
  let piecePanel;
  let sections = [];
  if (page) {
    // Pieces pages use the verified data rows, not the hidden directory links.
    const isPiecesRoute=!!(category && manufacturer && pattern);
    if (!isPiecesRoute) normalizeDirectoryDOM(page);
    sections = [...page.querySelectorAll('.cr-navigation-category')];
    const validCategory = sections.some(section => section.dataset.category === category);
    setNavigationSEO(validCategory ? category : null, validCategory ? manufacturer : null, validCategory ? pattern : null);
    if (validCategory) page.querySelector('.title').textContent = manufacturer ? category + ' — ' + manufacturer : category;
    const directoryBreadcrumb = document.createElement('nav');
    directoryBreadcrumb.className = 'cr-piece-breadcrumb';
    directoryBreadcrumb.setAttribute('aria-label', 'Breadcrumb');
    page.querySelector('.cr-directory').prepend(directoryBreadcrumb);
    if (validCategory) breadcrumbs(directoryBreadcrumb, manufacturer ? [{text:category,url:navigationUrl(category)}, {text:manufacturer}] : [{text:category}]);
    for (const section of (isPiecesRoute ? [] : sections)) {
      section.hidden = validCategory && section.dataset.category !== category;
      if (section.hidden) continue;
      for (const details of section.querySelectorAll('.cr-manufacturer')) {
        details.hidden = !!manufacturer && details.dataset.manufacturer !== manufacturer;
        details.open = !!manufacturer;
        const summary = details.querySelector('summary');
        const link = document.createElement('a');
        link.href = navigationUrl(section.dataset.category, details.dataset.manufacturer);
        link.textContent = details.dataset.manufacturer;
        summary.replaceChildren(link);
        summary.addEventListener('click', event => {
          event.preventDefault();
          location.assign(link.href);
        });
        if (manufacturer) summary.hidden = true;
      }
    }
    page.querySelector('input[type="search"]').addEventListener('input', event => {
      const term = event.target.value.trim().toLocaleLowerCase();
      let count = 0;
      for (const section of sections) {
        if (validCategory && section.dataset.category !== category) continue;
        let visible = 0;
        for (const details of section.querySelectorAll('.cr-manufacturer')) {
          if (manufacturer && details.dataset.manufacturer !== manufacturer) continue;
          if (details.dataset.stock === 'false') continue;
          const matchesManufacturer = details.dataset.manufacturer.toLocaleLowerCase().includes(term);
          let matches = 0;
          for (const item of details.querySelectorAll('.cr-patterns li')) {
            if (item.dataset.stock === 'false') continue;
            item.hidden = !!term && !matchesManufacturer && !item.textContent.toLocaleLowerCase().includes(term);
            if (!item.hidden) matches++;
          }
          details.hidden = !matches;
          if (matches) visible++;
          details.open = !!manufacturer || (!!term && !matchesManufacturer && matches > 0);
        }
        section.hidden = !visible;
        count += visible;
      }
      page.querySelector('.cr-navigation-empty').hidden = !!count;
    });
    if (category && manufacturer && pattern) {
      piecePanel = page.querySelector('.cr-pieces');
      page.querySelector('.cr-directory').hidden = true;
      piecePanel.hidden = false;
      page.querySelector('.title').textContent = manufacturer + ' — ' + pattern;
      piecePanel.querySelector('.cr-piece-status').textContent = piecePanel.dataset.loading;
      breadcrumbs(piecePanel.querySelector('.cr-piece-breadcrumb'), [{text:category,url:navigationUrl(category)}, {text:manufacturer,url:navigationUrl(category,manufacturer)}, {text:pattern}]);
      void renderPatternInformation(piecePanel, [category,manufacturer,pattern]);
    }
  }
  const targets = [...document.querySelectorAll('#menu-custom-breadcrumb, #menu-product-breadcrumb')];
  const currentProductRoute = document.getElementById('cr-current-product-navigation');
  if (!page && targets.length && targets.every(target => target.dataset.product) && currentProductRoute) {
    let route;
    try { route = canonicalIdentity(JSON.parse(currentProductRoute.textContent)); } catch {}
    if (route && route.url === location.pathname && ['China','Crystal','Flatware','Collectibles'].includes(route.category) && route.manufacturer && route.pattern && route.piece) {
      for (const target of targets) breadcrumbs(target,[
        {text:route.category,url:navigationUrl(route.category)},
        {text:route.manufacturer,url:navigationUrl(route.category,route.manufacturer)},
        {text:route.pattern,url:navigationUrl(route.category,route.manufacturer,route.pattern)},
        {text:target.dataset.product}
      ]);
      performance.mark('cr-product-breadcrumb-ready');
      return;
    }
    // Explicit but incomplete metadata must not silently use a stale old route.
    if (currentProductRoute.dataset.hasMarkers === 'true') return;
  }
  if ((!targets.length && !page) || !source) return;
  const directory = page && !piecePanel ? page.querySelector('.cr-directory') : null;
  const directoryStatus = document.createElement('p');
  if (directory) {
    directoryStatus.setAttribute('role', 'status');
    directoryStatus.textContent = manufacturer ? 'Loading available patterns…' : 'Loading available manufacturers…';
    directory.before(directoryStatus);
    directory.hidden = true;
  }
  if (directory && ['China','Crystal','Flatware','Collectibles'].includes(category) && preparedSource && params.get('cr_prepared_off') !== '1') {
    try {
      const data = await readJSON(preparedSource.replace('__CATEGORY__',encodeURIComponent(category)), {signal:AbortSignal.timeout(1800)});
      const age = Date.now() - data.checkedAt;
      const preparedRows = data.categories?.[category] || (data.category === category ? data.rows : null);
      if (data.schema !== 1 || !Number.isSafeInteger(data.checkedAt) || age < 0 || age > 600000 || !Array.isArray(preparedRows)) throw Error('Prepared directory unavailable');
      const identities = new Set();
      for (const row of preparedRows) {
        if (!Array.isArray(row) || row.length !== 3 || row.some(value=>typeof value !== 'string' || !value)) throw Error('Invalid prepared row');
        const key=JSON.stringify(row.slice(0,2));
        if (identities.has(key)) throw Error('Duplicate prepared route');
        identities.add(key);
        const destination=new URL(row[2],location.origin);
        const isPattern=destination.pathname === '/pages/navigation' && destination.searchParams.get('nav') === category && destination.searchParams.get('manufacturer') === row[0] && destination.searchParams.get('pattern') === row[1];
        const isCollection=/^\/collections\/[^/?#]+$/.test(row[2]);
        if (destination.origin !== location.origin || (!isPattern && !isCollection)) throw Error('Invalid prepared destination');
      }
      const container=page.querySelector('.navigations'), section=document.createElement('section');
      section.className='cr-navigation-category'; section.dataset.category=category;
      const heading=document.createElement('h2');heading.textContent=manufacturer || category;section.append(heading);
      const holder=document.createElement('div');holder.className='cr-manufacturers';section.append(holder);
      const manufacturers=new Map();
      for (const [name,patternName,href] of preparedRows) {
        if (manufacturer && manufacturer !== name) continue;
        if (!manufacturers.has(name)) {
          const details=document.createElement('details');details.className='cr-manufacturer';details.dataset.manufacturer=name;details.dataset.stock='true';details.open=!!manufacturer;
          const summary=document.createElement('summary');summary.hidden=!!manufacturer;
          const link=document.createElement('a');link.href=navigationUrl(category,name);link.textContent=name;summary.append(link);
          summary.addEventListener('click',event=>{event.preventDefault();location.assign(link.href);});details.append(summary);
          const list=document.createElement('ul');list.className='cr-patterns';list.setAttribute('role','list');details.append(list);holder.append(details);manufacturers.set(name,list);
        }
        const item=document.createElement('li'),link=document.createElement('a');item.dataset.stock='true';link.href=href;link.textContent=patternName;item.append(link);manufacturers.get(name).append(item);
      }
      container.replaceChildren(section);sections=[section];directory.hidden=false;directoryStatus.textContent='';page.dataset.directorySource='prepared';
      performance.mark('cr-directory-ready');performance.measure('cr-directory-ready','cr-navigation-start','cr-directory-ready');
      page.querySelector('input[type="search"]').dispatchEvent(new Event('input'));
      return;
    } catch {}
  }
  const pendingStock = new Map();
  const partialStock = new Set();
  const partialRoutes = new Map();
  let onStockProgress;
  const readStock = (path, number = 1) => {
    const url = path + '?view=cr-stock-index&page=' + number;
    if (!pendingStock.has(url)) pendingStock.set(url,readJSON(url).then(result=>{
      if (!Array.isArray(result.handles) || !Number.isInteger(result.pages) || result.pages < 1 || result.pages > 100) throw new Error('Invalid stock data');
      if (path === '/collections/all') {
        result.handles.forEach(handle=>partialStock.add('/products/'+handle));
        (result.navigation || []).filter(Boolean).forEach(product=>partialRoutes.set(product.url,product));
        onStockProgress?.();
      }
      return result;
    }));
    return pendingStock.get(url);
  };
  let warmDirectory = false;
  try {
    const cached=JSON.parse(sessionStorage.getItem('cr-navigation-index-v2:'+source));
    warmDirectory=!!cached && Date.now()-cached.time<60000 && Array.isArray(cached.products) && Array.isArray(cached.handles) && Array.isArray(cached.collections);
  } catch {}
  // Overlap the first directory stock read with the static navigation download.
  const directoryStock = directory && !warmDirectory ? readStock('/collections/all').then(async first=>{
    const pages=Array.from({length:first.pages-1},(_,i)=>i+2);
    await Promise.all(Array.from({length:Math.min(8,pages.length)},async()=>{
      while(pages.length) await readStock('/collections/all',pages.shift());
    }));
    return first;
  }).catch(()=>null) : null;
  const selectedSource = (directory || piecePanel) && directorySource ? directorySource : source;
  const patternPrefix = piecePanel ? '/collections/vendors?view=cr-pattern&q=' + encodeURIComponent(pattern) + '&page=' : null;
  // Start the current product request alongside the small legacy identity index.
  const firstPatternPage = patternPrefix ? readJSON(patternPrefix + 1).catch(() => null) : null;
  const scoped=piecePanel && globalThis.__crNavigationScoped;
  const scopedValid=scoped && scoped.source===directorySource && scoped.routeKey===JSON.stringify([category,manufacturer]);
  const readIdentity=()=>readJSON(selectedSource).then(async data=>{
    const scopedFiles=piecePanel && data.manufacturers ? Object.entries(data.manufacturers[category] || {}).filter(([name])=>canonicalMaker(category,name)===manufacturer).flatMap(([,files])=>files) : [];
    const files=scopedFiles.length?[...new Set(scopedFiles)]:data.categories?.[category] || data.files;
    return Array.isArray(data)?data:(await Promise.all(files.map(file=>readJSON(new URL(file,new URL(selectedSource,location.origin)).href)))).flat();
  });
  (scopedValid?scoped.rows.catch(readIdentity):readIdentity()).then(async data => {
    const files = data.categories?.[category] || data.files;
    let rows = Array.isArray(data) ? data : (await Promise.all(files.map(async file => {
      return readJSON(new URL(file, new URL(selectedSource, location.origin)).href);
    }))).flat();
    if (!Array.isArray(rows)) throw new Error('Invalid navigation data');
    rows=mergeIdentityRows(rows);
    if (!page && currentProductRoute && currentProductRoute.dataset.hasMarkers !== 'true' && targets.length && targets.every(target=>target.dataset.product)) {
      const path=location.pathname.match(/\/products\/[^/]+/)?.[0];
      const candidates=rows.filter(row=>row.products?.some(product=>product.url===path));
      if (candidates.length === 1) {
        const row=candidates[0];
        for (const target of targets) breadcrumbs(target,[
          {text:row.category,url:navigationUrl(row.category)},
          {text:row.manufacturer,url:navigationUrl(row.category,row.manufacturer)},
          {text:row.pattern,url:navigationUrl(row.category,row.manufacturer,row.pattern)},
          {text:target.dataset.product}
        ]);
      }
      // No stock lookup is needed to label the product already being viewed.
      return;
    }
    if (directory && !manufacturer && !warmDirectory) {
      // Build row and DOM associations once. The old progress callback queried
      // and rewrote every pattern on each of the twenty catalog responses.
      const groupsByManufacturer = new Map();
      for (const row of rows) {
        const key = JSON.stringify([row.category,row.manufacturer]);
        if (!groupsByManufacturer.has(key)) groupsByManufacturer.set(key,new Map());
        groupsByManufacturer.get(key).set(row.pattern,row);
      }
      const entries = [];
      for (const section of sections) {
        if (category && section.dataset.category !== category) continue;
        for (const details of section.querySelectorAll('.cr-manufacturer')) {
          const groups=groupsByManufacturer.get(JSON.stringify([section.dataset.category,details.dataset.manufacturer]));
          const items=[...details.querySelectorAll('.cr-patterns li')].map(item=>({item,row:groups?.get(item.textContent.trim()),stock:null}));
          entries.push({details,items,stock:null});
        }
      }
      onStockProgress=()=>{
        let visible=0, changed=false;
        for (const entry of entries) {
          let hasStock=false;
          for (const state of entry.items) {
            const row=state.row;
            const stocked=!!row?.products?.some(product=>{
              if (!partialStock.has(product.url)) return false;
              const native=partialRoutes.get(product.url);
              return !native || native.category===row.category && native.manufacturer===row.manufacturer && native.pattern===row.pattern;
            });
            if (stocked) hasStock=true;
            if (state.stock !== stocked) {
              state.stock=stocked;
              state.item.dataset.stock=String(stocked);
              state.item.hidden=!stocked;
              changed=true;
            }
          }
          if (entry.stock !== hasStock) {
            entry.stock=hasStock;
            entry.details.hidden=!hasStock;
            entry.details.dataset.stock=String(hasStock);
            changed=true;
          }
          if (hasStock) visible++;
        }
        if (visible) {
          if (directory.hidden) {
            directory.hidden=false;
            performance.mark('cr-directory-first-results');
            performance.measure('cr-directory-first-results','cr-navigation-start','cr-directory-first-results');
          }
          directoryStatus.textContent='Checking for additional manufacturers…';
          if (changed) page.querySelector('input[type="search"]').dispatchEvent(new Event('input'));
        }
      };
      onStockProgress();
    }
    if (piecePanel) {
      try {
        const prefix = patternPrefix;
        const first = await firstPatternPage;
        const validPage = (value, number) => !!value && Array.isArray(value.products) && value.vendor?.toLocaleLowerCase() === pattern.toLocaleLowerCase() && Number.isInteger(value.pages) && value.pages >= 1 && value.pages <= 100 && value.page === number && Number.isInteger(value.total) && value.total >= 0;
        if (!validPage(first,1)) throw new Error('Invalid pattern lookup');
        const current = [...first.products];
        const remaining = Array.from({length:first.pages-1},(_,i)=>i+2);
        await Promise.all(Array.from({length:Math.min(4,remaining.length)},async()=>{
          while (remaining.length) {
            const number = remaining.shift(), result = await readJSON(prefix + number);
            if (!validPage(result,number) || result.pages !== first.pages || result.total !== first.total) throw new Error('Incomplete pattern lookup');
            current.push(...result.products);
          }
        }));
        if (current.length !== first.total) throw new Error('Pattern count changed during lookup');
        const known = rows.find(row => row.category === category && row.manufacturer === manufacturer && row.pattern === pattern);
        const knownUrls = new Set((known?.products || []).map(product=>product.url));
        const byUrl = new Map();
        const inspect = product => {
          if (!/^\/products\/[^/?#]+$/.test(product.url) || typeof product.title !== 'string' || typeof product.in_stock !== 'boolean' || typeof product.has_markers !== 'boolean' || byUrl.has(product.url)) throw new Error('Invalid pattern product');
          byUrl.set(product.url,product);
          if (product.has_markers && !product.native) throw new Error('Incomplete product navigation metadata');
        };
        current.forEach(inspect);
        const missing = [...knownUrls].filter(url=>!byUrl.has(url));
        await Promise.all(Array.from({length:Math.min(4,missing.length)},async()=>{
          while (missing.length) {
            const url=missing.shift(), product=await readJSON(url+'?view=cr-stock');
            if (product.url !== url) throw new Error('Product URL changed');
            inspect(product);
          }
        }));
        const selected = [...byUrl.values()].filter(product => product.native ? product.native.category === category && product.native.manufacturer === manufacturer && product.native.pattern === pattern : knownUrls.has(product.url));
        if (!known && !selected.length) throw new Error('Unknown pattern');
        const list=piecePanel.querySelector('.cr-piece-list');
        list.replaceChildren();
        for (const product of selected.filter(product=>product.in_stock)) {
          const item=document.createElement('li'),link=document.createElement('a');
          link.href=product.url;link.textContent=product.title;
          if (product.featured_image) {
            const image=document.createElement('img');setPieceImagePriority(image,list);image.src=product.featured_image;image.alt='';image.width=480;image.height=480;
            image.decoding='async';image.addEventListener('error',()=>image.remove(),{once:true});link.prepend(image);
          }
          item.append(link);list.append(item);
        }
        piecePanel.dataset.lookup='pattern';
        piecePanel.querySelector('.cr-piece-status').textContent=list.children.length+' '+piecePanel.dataset.piecesLabel;
        return;
      } catch {
        // The compact index omits titles. Restore full rows before the legacy fallback.
        if (selectedSource !== source) {
          const full = await readJSON(source);
          rows = Array.isArray(full) ? full : (await Promise.all(full.files.map(file =>
            readJSON(new URL(file, new URL(source, location.origin)).href)
          ))).flat();
          if (!Array.isArray(rows)) throw new Error('Invalid fallback navigation data');
          rows=mergeIdentityRows(rows);
        }
      }
    }
    let firstPaint = Promise.resolve();
    if (piecePanel) {
      const known = rows.find(row => row.category === category && row.manufacturer === manufacturer && row.pattern === pattern);
      const list = piecePanel.querySelector('.cr-piece-list');
      const jobs = (known?.products || []).map((product, order) => async () => {
        try {
          const current = await readJSON(product.url + '?view=cr-stock');
          if (!current.in_stock) return;
          const item = document.createElement('li'), link = document.createElement('a');
          item.style.order = String(order); link.href = product.url; link.textContent = product.title;
          if (current.featured_image) {
            const image = document.createElement('img'), url = new URL(current.featured_image, location.origin);
            setPieceImagePriority(image,list); url.searchParams.set('width','480'); image.src = url.href; image.alt = ''; image.width = 480; image.height = 480;
            image.decoding = 'async'; image.addEventListener('error',()=>image.remove(),{once:true}); link.prepend(image);
          }
          item.append(link); list.append(item);
          piecePanel.querySelector('.cr-piece-status').textContent = list.children.length + ' ' + piecePanel.dataset.piecesLabel + ' — checking for new pieces…';
        } catch {}
      });
      firstPaint = Promise.all(Array.from({length:Math.min(4,jobs.length)}, async () => {
        while (jobs.length) await jobs.shift()();
      }));
    }
    if (directory && manufacturer) {
      firstPaint = (async () => {
        try {
          const prefix = '/search?view=cr-navigation-index&type=product&options[unavailable_products]=show&q=' + encodeURIComponent(JSON.stringify(manufacturer)) + '&page=';
          const first = await readJSON(prefix + 1);
          if (!Array.isArray(first.handles) || !Number.isInteger(first.pages) || first.pages < 1 || first.pages > 100) return;
          const handles = new Set(first.handles.map(handle => '/products/' + handle));
          const pages = Array.from({length:first.pages-1}, (_,i)=>i+2);
          await Promise.all(Array.from({length:Math.min(4,pages.length)}, async()=>{
            while (pages.length) {
              const result = await readJSON(prefix + pages.shift());
              if (!Array.isArray(result.handles) || result.pages !== first.pages) throw new Error('Incomplete search');
              result.handles.forEach(handle=>handles.add('/products/'+handle));
            }
          }));
          let count = 0;
          for (const section of sections) {
            if (section.dataset.category !== category) continue;
            section.querySelector('h2').textContent = manufacturer;
            for (const details of section.querySelectorAll('.cr-manufacturer')) {
              if (details.dataset.manufacturer !== manufacturer) continue;
              for (const item of details.querySelectorAll('.cr-patterns li')) {
                const row = rows.find(row=>row.category===category && row.manufacturer===manufacturer && row.pattern===item.textContent.trim());
                item.hidden = !row?.products?.some(product=>handles.has(product.url));
                if (!item.hidden) count++;
              }
              details.hidden = !count;
            }
          }
          if (count) {
            directory.hidden = false; directoryStatus.textContent = 'Checking for new patterns…';
            page.querySelector('input[type="search"]').dispatchEvent(new Event('input'));
          }
        } catch {}
      })();
    }
    const indexKey = 'cr-navigation-index-v2:' + source;
    let index;
    try {
      const cached = JSON.parse(sessionStorage.getItem(indexKey));
      if (cached && Date.now() - cached.time < (piecePanel ? 300000 : 60000)
          && Array.isArray(cached.products) && Array.isArray(cached.handles) && Array.isArray(cached.collections)) index = cached;
    } catch {}
    const first = index ? {navigation:index.products,handles:index.handles,pages:1,stocked_collections:index.collections,collections_complete:index.collectionsComplete} : (await directoryStock || await readStock('/collections/all'));
    if (!Array.isArray(first.navigation)) throw new Error('Native navigation data unavailable');
    const stocked = new Set(first.handles.map(handle => '/products/' + handle));
    const stockedCollections = new Set(first.stocked_collections || []);
    let collectionsComplete = first.collections_complete === true && Array.isArray(first.stocked_collections);
    const nativeProducts = first.navigation.filter(Boolean).map(canonicalIdentity);
    const pages = Array.from({length:first.pages - 1}, (_,index) => index + 2);
    await Promise.all(Array.from({length:Math.min(4,pages.length)}, async () => {
      while (pages.length) {
        const result = await readStock('/collections/all',pages.shift());
        if (!Array.isArray(result.navigation) || result.pages !== first.pages) throw new Error('Incomplete navigation index');
        for (const handle of result.handles) stocked.add('/products/' + handle);
        if (result.collections_complete !== true || !Array.isArray(result.stocked_collections)) collectionsComplete = false;
        for (const path of result.stocked_collections || []) stockedCollections.add(path);
        nativeProducts.push(...result.navigation.filter(Boolean));
      }
    }));
    if (!index) {
      try { sessionStorage.setItem(indexKey, JSON.stringify({time:Date.now(),products:nativeProducts,handles:[...stocked].map(url => url.slice(10)),collections:[...stockedCollections],collectionsComplete})); } catch {}
    }
    onStockProgress=null;
    const identity = row => JSON.stringify([row.category,row.manufacturer,row.pattern]);
    const nativeByUrl = new Map();
    for (const product of nativeProducts) {
      if (!['China','Crystal','Flatware','Collectibles'].includes(product.category) || !product.manufacturer || !product.pattern || !product.piece || !/^\/products\/[^/?#]+$/.test(product.url)) throw new Error('Invalid native product');
      if (nativeByUrl.has(product.url) && identity(nativeByUrl.get(product.url)) !== identity(product)) throw new Error('Ambiguous native product route');
      nativeByUrl.set(product.url,product);
    }
    // Explicit Shopify metadata replaces only that product's old route.
    // Each distinct product URL is retained, including duplicate SKU destinations.
    rows = rows.map(row => ({...row,products:(row.products || []).filter(product => !nativeByUrl.has(product.url))}));
    const grouped = new Map(rows.map(row => [identity(row),row]));
    for (const product of nativeByUrl.values()) {
      const key = identity(product);
      if (!grouped.has(key)) { const row = {category:product.category,manufacturer:product.manufacturer,pattern:product.pattern,products:[]}; grouped.set(key,row); rows.push(row); }
      grouped.get(key).products.push({url:product.url,title:product.title,piece:product.piece});
    }
    if (directory) {
      await firstPaint;
      const container = page.querySelector('.navigations');
      container.replaceChildren();
      const categoryNodes = new Map();
      const visibleRows = rows.filter(row => (!category || row.category === category) && (!manufacturer || row.manufacturer === manufacturer));
      for (const row of visibleRows.sort((a,b) => identity(a).localeCompare(identity(b)))) {
        if (!categoryNodes.has(row.category)) {
          const section = document.createElement('section'); section.className = 'cr-navigation-category'; section.dataset.category = row.category;
          const heading = document.createElement('h2'); heading.textContent = manufacturer || row.category; section.append(heading);
          const holder = document.createElement('div'); holder.className = 'cr-manufacturers'; section.append(holder); container.append(section);
          section.hidden = !!category && row.category !== category;
          categoryNodes.set(row.category,{section,holder,manufacturers:new Map()});
        }
        const entry = categoryNodes.get(row.category);
        if (!entry.manufacturers.has(row.manufacturer)) {
          const details = document.createElement('details'); details.className = 'cr-manufacturer'; details.dataset.manufacturer = row.manufacturer; details.open = !!manufacturer;
          details.hidden = !!manufacturer && row.manufacturer !== manufacturer;
          const summary = document.createElement('summary'); summary.hidden = !!manufacturer;
          const link = document.createElement('a'); link.textContent = row.manufacturer; link.href = navigationUrl(row.category,row.manufacturer); summary.append(link);
          summary.addEventListener('click',event => {event.preventDefault();location.assign(link.href);}); details.append(summary);
          const list = document.createElement('ul'); list.className = 'cr-patterns'; list.setAttribute('role','list'); details.append(list); entry.holder.append(details);
          entry.manufacturers.set(row.manufacturer,list);
        }
        const item = document.createElement('li'), link = document.createElement('a'); link.textContent = row.pattern;
        link.href = row.products.length ? navigationUrl(row.category,row.manufacturer,row.pattern) : row.url || row.legacyUrl || navigationUrl(row.category,row.manufacturer,row.pattern);
        item.append(link); entry.manufacturers.get(row.manufacturer).append(item);
      }
      sections = [...page.querySelectorAll('.cr-navigation-category')];
      const groupStock = async row => {
        if (row.products?.length) return row.products.some(product => stocked.has(product.url));
        if (!row.url?.startsWith('/collections/')) return false;
        if (collectionsComplete) return stockedCollections.has(row.url);
        const result = await readStock(row.url);
        if (result.handles.length) return true;
        for (let number = 2; number <= result.pages; number++) if ((await readStock(row.url,number)).handles.length) return true;
        return false;
      };
      const jobs = [];
      for (const section of page.querySelectorAll('.cr-navigation-category')) {
        if (category && section.dataset.category !== category) continue;
        for (const details of section.querySelectorAll('.cr-manufacturer')) {
          if (manufacturer && details.dataset.manufacturer !== manufacturer) continue;
          jobs.push(async () => {
            const groups = rows.filter(row => row.category === section.dataset.category && row.manufacturer === details.dataset.manufacturer);
            let anyStock = groups.some(row => row.products?.some(product => stocked.has(product.url)));
            {
              for (const item of details.querySelectorAll('.cr-patterns li')) {
                const link = item.querySelector('a');
                const row = groups.find(row => row.pattern === link.textContent);
                if (!row) throw new Error('Unknown pattern');
                const hasStock = await groupStock(row);
                item.dataset.stock = String(hasStock);
                item.hidden = !hasStock;
              }
              anyStock = [...details.querySelectorAll('.cr-patterns li')].some(item => item.dataset.stock === 'true');
            }
            details.dataset.stock = String(anyStock);
            details.hidden = !anyStock;
          });
        }
      }
      await Promise.all(Array.from({length:Math.min(4,jobs.length)}, async () => {
        while (jobs.length) await jobs.shift()();
      }));
      directory.hidden = false;
      directoryStatus.textContent = '';
      performance.mark('cr-directory-ready');
      performance.measure('cr-directory-ready','cr-navigation-start','cr-directory-ready');
      page.querySelector('input[type="search"]').dispatchEvent(new Event('input'));
    }
    if (piecePanel) {
      await firstPaint;
      const group = rows.find(row => row.category === category && row.manufacturer === manufacturer && row.pattern === pattern);
      if (!group?.products?.length) throw new Error('Pattern not found');
      const list = piecePanel.querySelector('.cr-piece-list');
      list.replaceChildren();
      const photoTasks = [];
      for (const product of group.products) {
        const item = document.createElement('li');
        item.style.order = String(photoTasks.length);
        const link = document.createElement('a');
        link.href = product.url;
        link.textContent = product.title;
        item.append(link);
        photoTasks.push(async () => {
          try {
            const currentProduct = await readJSON(product.url + '?view=cr-stock');
            if (!currentProduct.in_stock) return;
            list.append(item);
            if (!currentProduct.featured_image) return;
            const image = document.createElement('img');
            const imageUrl = new URL(currentProduct.featured_image, location.origin);
            imageUrl.searchParams.set('width', '480');
            setPieceImagePriority(image,list);
            image.src = imageUrl.href;
            image.alt = '';
            image.width = 480;
            image.height = 480;
            image.decoding = 'async';
            image.addEventListener('error', () => image.remove(), {once:true});
            link.prepend(image);
          } catch { stockCheckFailed = true; }
        });
      }
      const loadPhotos = async () => {
        while (photoTasks.length) await photoTasks.shift()();
      };
      let stockCheckFailed = false;
      await Promise.all(Array.from({length:Math.min(4,photoTasks.length)}, loadPhotos));
      piecePanel.querySelector('.cr-piece-status').textContent = stockCheckFailed ? piecePanel.dataset.unavailable : list.children.length + ' ' + piecePanel.dataset.piecesLabel;
    }
    for (const target of targets) {
      let candidates;
      if (target.dataset.product) {
        const productPath = location.pathname.match(/\/products\/[^/]+/)?.[0];
        candidates = rows.filter(row => row.products?.some(product => product.url === productPath));
      } else {
        const collectionPath = location.pathname.match(/\/collections\/[^/]+/)?.[0];
        candidates = rows.filter(row => row.legacyUrl === collectionPath || row.url === collectionPath);
      }
      if (candidates.length !== 1) continue;
      const row = candidates[0];
      const parts = [{text:row.category,url:navigationUrl(row.category)}, {text:row.manufacturer,url:navigationUrl(row.category,row.manufacturer)}, {text:row.pattern,url:row.products?.length?navigationUrl(row.category,row.manufacturer,row.pattern):row.url}];
      if (target.dataset.product) parts.push({text:target.dataset.product});
      breadcrumbs(target, parts);
    }
  }).catch(error => {
    if (directory) directoryStatus.textContent = page.querySelector('.cr-pieces').dataset.unavailable;
    if (piecePanel) {
      piecePanel.querySelector('.cr-piece-status').textContent = piecePanel.dataset.unavailable;
      page.querySelector('.cr-directory').hidden = false;
    }
    console.warn(error.message);
  });
})();


